import Styles from './Message.module.scss'
import cx from 'classnames'
import { MessageContent } from './Content/MessageContent'
import { MessageProps, PollingMessageProps } from './Types'
import { usePollMessage } from 'hooks/queries/chat/usePollMessage'
import { AIJobStatus } from 'types'
import { ErrorMessage } from './ErrorMessage'
import { LastMessageActions } from './LastMessageActions'

const Message = ({ message, isLastMessage }: MessageProps) => {
  const isProcessing = message.status && [AIJobStatus.Pending, AIJobStatus.Started].includes(message.status)
  let content = message.content

  if (isProcessing && content.length === 0) {
    content = [...content, { type: 'processing' }]
  }

  if (!content.length) return null

  return (
    <div className={cx(Styles.message, Styles[message.role])} data-testid={`message-${message.id}`}>
      {content.map((content, id) => (
        <MessageContent key={`${message.id}-${id}`} content={content} message={message} />
      ))}
      {!isProcessing &&
        isLastMessage &&
        message.role === 'assistant' &&
        !message.content.some((content) => content.type === 'unsupported_request') && (
          <LastMessageActions message={message} />
        )}
    </div>
  )
}

const PollingMessage = ({ threadId, id, isLastMessage }: PollingMessageProps) => {
  const { data: messageData } = usePollMessage({ threadId, id })

  if (!messageData) {
    return null
  }

  return <Message message={messageData.message} isLastMessage={isLastMessage} />
}

const MessageContainer = ({ message, isLastMessage }: MessageProps) => {
  if (message.status && [AIJobStatus.Pending, AIJobStatus.Started].includes(message.status)) {
    return <PollingMessage threadId={message.thread_id} id={message.id} />
  }

  if (message.status === AIJobStatus.Failed) {
    return <ErrorMessage message={message} />
  }

  return <Message message={message} isLastMessage={isLastMessage} />
}

export { MessageContainer as Message }
